/**
 * Convert backend status to display status
 * Backend uses "Deactive" but UI should display "Inactive"
 */
export const formatStatusForDisplay = (status) => {
  if (status === 'Deactive') {
    return 'Inactive';
  }
  return status;
};

/**
 * Convert display status to backend status
 * UI uses "Inactive" but backend expects "Deactive"
 */
export const formatStatusForBackend = (status) => {
  if (status === 'Inactive') {
    return 'Deactive';
  }
  return status;
};
